// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-index-productDay-odnkv{width:100%}.pages-index-productDayWrapper-supya.pages-index-mobile-bhpzr{margin-left:-12px;margin-right:-12px}.pages-index-productsBlock3-bxxpt{margin-bottom:24px}.pages-index-productsBlock3-bxxpt:last-child{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"productDay": "pages-index-productDay-odnkv",
	"productDayWrapper": "pages-index-productDayWrapper-supya",
	"mobile": "pages-index-mobile-bhpzr",
	"productsBlock3": "pages-index-productsBlock3-bxxpt"
};
module.exports = ___CSS_LOADER_EXPORT___;
